import BlockReviewCard from '@/components/cards/BlockReviewCard/index.vue';

export default {
  name: 'ContentBlockReview',
  components: { BlockReviewCard },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    positionCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
